var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { live, getCookie } from "../utils/tools";
import { getUrlParam } from "../utils/urlMethod";
import { loadAPPSDK } from "./methods";
export var wubaLog = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.pageType, pageType = _c === void 0 ? "default" : _c, _d = _b.actionType, actionType = _d === void 0 ? "show" : _d, _e = _b.params, params = _e === void 0 ? [] : _e, _f = _b.cate, cate = _f === void 0 ? "4,398038" : _f, _g = _b.realtime, realtime = _g === void 0 ? false : _g, _h = _b.top_level, top_level = _h === void 0 ? false : _h, _j = _b.json, json = _j === void 0 ? {} : _j;
    // let ua = navigator.userAgent.toLowerCase(),
    var trackOpts = { params: params, cate: cate, json: json, };
    var fromStr = getUrlParam("from")
        ? getUrlParam("from")
        : getCookie("from_code");
    var objStr = { from_code: fromStr };
    trackOpts.json = __assign(__assign({}, trackOpts.json), objStr);
    if (getUrlParam("debug") == 1) {
        console.log("无线埋点：", pageType, actionType, trackOpts);
    }
    loadAPPSDK()
        .then(function () {
        var curVersion = window.XINCHEAPP.util.getVersion(); // 
        // 版本判断 10.20新加的实时埋点参数
        var status = window.XINCHEAPP.util.compareVersion(curVersion, '10.20.0') >=
            0;
        if (status) {
            trackOpts.realtime = realtime;
            trackOpts.top_level = top_level;
            window.XINCHEAPP.action.setWeblog(pageType, actionType, trackOpts);
        }
        else {
            window.XINCHEAPP.action.setWeblog(pageType, actionType, trackOpts);
        }
    })
        .catch(function () {
        console.log("埋点 非app环境");
    });
};
/**
 * 微动态A元素绑定埋点统计
 */
export var aClickStatistics = function () {
    live(document, "a", "click", function (dom) {
        sendClickStatistics(dom);
    });
};
/**
 * 发送58app点击埋点统计
 * @param {dom} dom
 */
export var sendClickStatistics = function (dom) {
    var pageType = dom.getAttribute("data-pagetype"), actionType = dom.getAttribute("data-actiontype"), params = [], paramStr = dom.getAttribute("data-params"), jsonStr = dom.getAttribute("data-wuxianjson");
    if (paramStr) {
        var arr = paramStr.toString().split("|");
        arr.length > 0 &&
            arr.map(function (item) {
                // @ts-ignore
                if (!isNaN(item)) {
                    params.push("param-" + item);
                }
                else {
                    params.push(item);
                }
            });
    }
    var logObj = {
        pageType: pageType,
        actionType: actionType + "-click",
        params: params,
        json: {}
    };
    try {
        logObj.json = JSON.parse(jsonStr);
    }
    catch (error) { }
    // paramStr && params.push(parseFloat(paramStr).toString() == "NaN" ? paramStr : 'param-' + paramStr);
    if (pageType && actionType) {
        wubaLog(logObj);
    }
};
